/**
 * Company Credit Wallet APIs (BC_WALLET_BASE = /api/secure/bc/company-credits)
 * See docs/portals/business/business-portal-integraton-guide.md and company-onboarding-sequence-guide.md
 */
import {
  getBPDataWithoutParams,
  getBPDataWithParams,
  postBPDataWithoutParams,
} from '../../index'

const WALLET_BASE = '/api/secure/bc/company-credits'

/** GET /api/secure/bc/company-credits/recharge-model — business flow source of truth for preset options */
export function getRechargeModel() {
  return getBPDataWithoutParams(`${WALLET_BASE}/recharge-model`)
}

/** GET /api/secure/bc/company-credits/summary?usageUserId=... */
export function getWalletSummary(usageUserId = '') {
  const url = usageUserId
    ? `${WALLET_BASE}/summary?usageUserId=${encodeURIComponent(usageUserId)}`
    : `${WALLET_BASE}/summary`
  return getBPDataWithoutParams(url)
}

/** GET /api/secure/bc/company-credits/transactions */
export function getWalletTransactions(params = {}) {
  const { transactionType, event, from, to, page = 0, size = 50, sortBy = 'createdTime', sortDir = 'desc' } = params
  const query = { page, size, sortBy, sortDir }
  if (transactionType) query.transactionType = transactionType
  if (event) query.event = event
  if (from) query.from = from
  if (to) query.to = to
  return getBPDataWithParams(`${WALLET_BASE}/transactions`, query)
}

/** GET /api/secure/bc/company-credits/policy/templates */
export function getPolicyTemplates() {
  return getBPDataWithoutParams(`${WALLET_BASE}/policy/templates`)
}

/** POST /api/secure/bc/company-credits/policy/upsert */
export function upsertPolicy(body) {
  return postBPDataWithoutParams(`${WALLET_BASE}/policy/upsert`, body)
}

/** POST /api/secure/bc/company-credits/recharge-requests/create */
export function createRechargeRequest(body) {
  return postBPDataWithoutParams(`${WALLET_BASE}/recharge-requests/create`, body)
}

/** GET /api/secure/bc/company-credits/recharge-requests */
export function getRechargeRequests(params = {}) {
  const { status, paymentGateway, page = 0, size = 50 } = params
  const query = { page, size }
  if (status) query.status = status
  if (paymentGateway) query.paymentGateway = paymentGateway
  return getBPDataWithParams(`${WALLET_BASE}/recharge-requests`, query)
}

/** POST /api/secure/bc/company-credits/recharge-requests/cancel */
export function cancelRechargeRequest(body) {
  return postBPDataWithoutParams(`${WALLET_BASE}/recharge-requests/cancel`, body)
}

/** GET /api/secure/bc/company-credits/recharge-requests/payment-links */
export function getPaymentLinks(params = {}) {
  const { status, paymentGateway, page = 0, size = 50 } = params
  const query = { page, size }
  if (status) query.status = status
  if (paymentGateway) query.paymentGateway = paymentGateway
  return getBPDataWithParams(`${WALLET_BASE}/recharge-requests/payment-links`, query)
}

/** GET /api/secure/bc/company-credits/recharge-requests/payment-link?rechargeRequestId=... */
export function getPaymentLink(rechargeRequestId) {
  return getBPDataWithParams(`${WALLET_BASE}/recharge-requests/payment-link`, { rechargeRequestId })
}
